import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {PagingResolverService} from '@abstract/paging-resolver.service';
import {EquipmentListPagesService} from './equipment-list-pages.service';

@Injectable()
export class EquipmentListPagesResolver extends PagingResolverService {
    constructor(
        service: EquipmentListPagesService,
        router: Router,
    ) {
        super(service, router);
    }

    resolve(snapshot: ActivatedRouteSnapshot) {
        const service = this.resolverService as EquipmentListPagesService;


        /**
         * Если Id ТУ не поменялась
         * то сохраняем параметры фильтрации, а если это новая сущность, то сбрасываем.
         * Это позволит сохранить контекст работы, пока мы не перейдем к новой сущности
         */
        const id = +snapshot.parent.params.id;

        if (id !== service.objectId) {
            service.resetParams();
        }

        service.objectId = id;

        return super.resolve(snapshot);
    }
}
